"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AffiliateService = void 0;
//supportNumber: text display of agentNumber. Used by customers and internal agents.
//supportNumberForExternalAgent: text display of agentNumberForExternalAgent. Used by external agents.
const affiliateList = [
    {
        affiliate: 'default',
        logoUrl: { mobile: 'assets/ahoy_mobile.svg', desktop: 'assets/ahoy_desktop.svg' },
        supportNumber: '1-855-289-2469',
        agentNumber: '+18552892469',
        supportNumberForExternalAgent: '1-866-665-2469',
        agentNumberForExternalAgent: '+18666652469',
        hasChat: true,
    },
    {
        affiliate: 'yamaha',
        logoUrl: { mobile: 'assets/AndersonMobile.svg', desktop: 'assets/AndersonDesktop.svg' },
    },
    {
        affiliate: 'vrf',
        defaultExternalAgent: 'dana@vrfloans.com',
        defaultExternalAgent_DEV: 'partner@ahoy.insure',
        logoUrl: { mobile: 'assets/vrf-logo-with-ahoy-mobile.svg', desktop: 'assets/vrf-logo-with-ahoy-desktop.svg' },
    },
    {
        affiliate: 'reynolds',
        logoUrl: { mobile: 'assets/jared-logo-with-ahoy-mobile.svg', desktop: 'assets/jared-logo-with-ahoy-desktop.svg' },
    },
    {
        affiliate: 'magnum',
        logoUrl: { mobile: 'assets/magnum-logo.png', desktop: 'assets/magnum-logo.png' },
        hasChat: false,
        supportNumber: '1-224-348-2400',
        customClassMobile: 'mobile-width adj-height',
        agentNumber: '+12243482400',
    },
    {
        affiliate: 'asa-hilb-ahoy',
        logoUrl: { mobile: 'assets/HILB_ASA_LOGO_1.png', desktop: 'assets/HILB_ASA_LOGO_1.png' },
        hasChat: false,
        supportNumber: '1-800-232-0582',
        agentNumber: '+18002320582',
        defaultExternalAgent: 'cmckeon@hilbgroup.com',
        customClassDesktop: 'mobile-width',
        customClassMobile: 'mobile-width',
        discount: '5%',
    },
    {
        affiliate: 'covered',
        logoUrl: { mobile: 'assets/Powered-by_Mob-covered.png', desktop: 'assets/Powered-by-covered.png' },
        hasChat: false,
        supportNumber: '1-855-289-2469',
        agentNumber: '+18552892469',
        customClassMobile: 'mobile-width adj-height',
        removeAhoyLogo: true,
    },
    {
        affiliate: 'covered-aff',
        logoUrl: { mobile: 'assets/ahoy_mobile.svg', desktop: 'assets/ahoy_desktop.svg' },
        hasChat: false,
        supportNumber: '1-855-289-2469',
        agentNumber: '+18552892469',
    },
    {
        affiliate: 'boatfix-aff',
        logoUrl: { mobile: 'assets/ahoy_mobile.svg', desktop: 'assets/ahoy_desktop.svg' },
        hasChat: true,
        supportNumber: '1-855-289-2469',
        agentNumber: '+18552892469',
    },
    {
        affiliate: 'outdoor-advinsure-aff',
        logoUrl: { mobile: 'assets/outdoor-advinsure-aff.png', desktop: 'assets/outdoor-advinsure-aff.png' },
        supportNumber: '1-855-289-2469',
        agentNumber: '+18552892469',
        hasChat: true,
        defaultExternalAgent: 'eric@onthewatermarine.com',
        customClassDesktop: 'mobile-width adj-height',
        customClassMobile: 'mobile-width adj-height',
        removeAhoyLogo: true,
    },
    {
        affiliate: 'bee-insurance-inc-aff',
        logoUrl: { mobile: 'assets/Bee-Insurance-Logo.png', desktop: 'assets/Bee-Insurance-Logo.png' },
        supportNumber: '1-855-289-2469',
        agentNumber: '+18552892469',
        hasChat: true,
        customClassMobile: 'mobile-width',
        customClassDesktop: 'mobile-width',
    },
    {
        affiliate: 'insurish',
        logoUrl: { mobile: 'assets/Powered-by_Mob.png', desktop: 'assets/powered_by_ahoy.svg' },
        supportNumber: '1-248-458-4357',
        agentNumber: '+12484584357',
        hasChat: false,
        customClassDesktop: 'mobile-height',
        customClassMobile: 'mobile-height',
    },
    {
        affiliate: 'roamly',
        logoUrl: { mobile: 'assets/Roamly-Powered-by_Mob.png', desktop: 'assets/Roamly-Powered-by.png' },
        supportNumber: '1-737-258-7543',
        agentNumber: '+17372587543',
        hasChat: false,
        customClassDesktop: 'mobile-width adj-height',
        customClassMobile: 'mobile-width adj-height',
    },
    {
        affiliate: 'safer-boater',
        logoUrl: { mobile: 'assets/SaferBoater-Powered-by_Mob.png', desktop: 'assets/SaferBoater-Powered-by-desktop.png' },
        supportNumber: '1-855-289-2469',
        agentNumber: '+18552892469',
        hasChat: true,
        customClassDesktop: 'desktop-adj-width',
        customClassMobile: 'mobile-width adj-height',
        discount: '5%',
    },
    {
        affiliate: 'boat-value',
        logoUrl: { mobile: 'assets/Powered-by_Mob-BV.png', desktop: 'assets/Powered-by-BV.png' },
        supportNumber: '1-855-289-2469',
        agentNumber: '+18552892469',
        hasChat: true,
        customClassDesktop: 'desktop-adj-width',
        customClassMobile: 'mobile-width adj-height',
    },
    {
        affiliate: 'sun-country',
        logoUrl: { mobile: 'assets/Powered-by_Mob-Wozencraft-SCMG.png', desktop: 'assets/Powered-by-Wozencraft-SCMG.png' },
        supportNumber: '1-714-263-2626',
        agentNumber: '+17142632626',
        defaultExternalAgent: 'devin@wozencraftinsurance.com',
        hasChat: false,
        customClassDesktop: 'desktop-adj-width-14',
        customClassMobile: 'mobile-width adj-height',
    },
    {
        affiliate: 'voom',
        logoUrl: { mobile: 'assets/VOOM-Powered-by_Mob.png', desktop: 'assets/VOOM-Powered-by.png' },
        supportNumber: '1-855-289-2469',
        agentNumber: '+18552892469',
        defaultExternalAgent: 'tylerm@voominsurance.com',
        hasChat: true,
        customClassDesktop: 'desktop-adj-width-14',
        customClassMobile: 'mobile-width adj-height',
    },
    {
        affiliate: '2nd-state-insurance-agency',
        logoUrl: { mobile: 'assets/2nd-state--Powered-by_Mob.png', desktop: 'assets/2nd-state-Powered-by.png' },
        supportNumber: '1-888-929-2628',
        agentNumber: '+18889292628',
        defaultExternalAgent: 'jonathan@2ndstateinsurance.com',
        hasChat: true,
        customClassDesktop: 'desktop-adj-width-14',
        customClassMobile: 'mobile-width adj-height',
    },
    {
        affiliate: 'mig-agency',
        logoUrl: { mobile: 'assets/ahoy_mobile.svg', desktop: 'assets/ahoy_desktop.svg' },
        supportNumber: '1-855-289-2469',
        agentNumber: '+18552892469',
        defaultExternalAgent: 'Elizabeth.king@miginsgroup.com',
        hasChat: true,
    },
];
let instance;
class AffiliateService {
    static serviceName = 'affiliateService';
    affiliate;
    defaultAffiliate = affiliateList[0];
    constructor() {
        instance = this;
        this.affiliate = '';
    }
    static getInstance() {
        return instance;
    }
    getAffiliate() {
        return this.affiliate;
    }
    setAffiliate(affiliate) {
        this.affiliate = affiliate?.toLowerCase() || '';
    }
    getIsChat() {
        const item = affiliateList.find(el => el.affiliate === this.affiliate);
        return item?.hasChat !== undefined ? item?.hasChat : this.defaultAffiliate.hasChat;
    }
    getAffiliateObj() {
        const item = affiliateList.find(el => el.affiliate === this.affiliate);
        return item || null;
    }
    getAffiliateData(name) {
        const item = affiliateList.find(el => el.affiliate === name);
        return item || null;
    }
    getAgentNumber() {
        const item = affiliateList.find(el => el.affiliate === this.affiliate);
        return item?.agentNumber || this.defaultAffiliate.agentNumber;
    }
    getSupportNumber() {
        const item = affiliateList.find(el => el.affiliate === this.affiliate);
        return item?.supportNumber || this.defaultAffiliate.supportNumber;
    }
    getExternalAgentSupportNumber() {
        const item = affiliateList.find(el => el.affiliate === this.affiliate);
        return item?.supportNumberForExternalAgent || this.defaultAffiliate.supportNumberForExternalAgent;
    }
    getExternalAgentPhoneNumber() {
        const item = affiliateList.find(el => el.affiliate === this.affiliate);
        return item?.agentNumberForExternalAgent || this.defaultAffiliate.agentNumberForExternalAgent;
    }
    // gets the logo used in lh-side-about-us-features. it is same as the mobile logo
    // eslint-disable-next-line no-empty-pattern
    getBrandLogo({}) {
        const item = affiliateList.find(el => el.affiliate === this.affiliate);
        return item?.logoUrl?.mobile;
    }
    // this is for the funnel. we used to return also the landing page logo, but then 
    // it was integrated in WP so we don't need it anymore
    // eslint-disable-next-line no-empty-pattern
    getLogoUrl({}) {
        const item = affiliateList.find(el => el.affiliate === this.affiliate);
        return item?.logoUrl || this.defaultAffiliate.logoUrl;
    }
    isAffiliateExist(affiliate) {
        const item = affiliateList.find(el => el.affiliate === affiliate?.toLowerCase() || '');
        return item !== undefined;
    }
    // returns desktop custom classes
    getCustomClassDesktop() {
        const customClass = this.getAffiliateObj()?.customClassDesktop;
        return customClass || null;
    }
    // returns mobile custom classes
    getCustomClassMobile() {
        const customClass = this.getAffiliateObj()?.customClassMobile;
        return customClass || null;
    }
    // checks if the affiliate needs to remove the ahoy logo
    checkRemoveAhoyLogo() {
        const removeAhoyLogo = !!this.getAffiliateObj()?.removeAhoyLogo;
        return removeAhoyLogo || false;
    }
    isDiscount() {
        const discount = this.getAffiliateObj()?.discount;
        return discount || '';
    }
}
exports.AffiliateService = AffiliateService;
